(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'ax-cart-drawer';

  function drawer() { return document.getElementById('ax-cart-drawer'); }
  function open() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open');
    document.documentElement.classList.add('ax-lock');
    var c = d.querySelector('.ax-drawer__close'); if (c) c.focus({ preventScroll: true });
    return true;
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('ax-lock');
  }
  function render(sections) {
    if (!sections || !sections[SECTION]) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = sections[SECTION];
    var fresh = tmp.querySelector('.ax-drawer__panel');
    var cur = drawer() && drawer().querySelector('.ax-drawer__panel');
    if (fresh && cur) cur.replaceWith(fresh);
  }
  function setCount(n) {
    document.querySelectorAll('[data-ax-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function fail(err) {
    alert((err && (err.description || err.message)) || 'Something went wrong. Please try again.');
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    var ours = f.classList.contains('ax-buy-form');
    if (!ours && document.documentElement.dataset.axCatchAll !== '1') return;
    if (!drawer()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = e.submitter || f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    var fd = new FormData(f);
    fd.append('sections', SECTION);
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        render(j.sections);
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { setCount(cart.item_count); open(); })
      .catch(fail)
      .finally(function () { if (btn) btn.disabled = false; });
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ax-cart-open],[data-ax-cart-close],[data-ax-line]');
    if (!t) return;
    if (t.hasAttribute('data-ax-cart-open')) { if (open()) e.preventDefault(); return; }
    if (t.hasAttribute('data-ax-cart-close')) { close(); return; }
    t.disabled = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +t.dataset.axLine, quantity: +t.dataset.axQty, sections: SECTION })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) { render(cart.sections); setCount(cart.item_count); })
      .catch(function (err) { t.disabled = false; fail(err); });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

(function(){
  var raf=0,corr=0;
  function hb(){var el=document.querySelector('.ax-header');return el?Math.max(0,Math.round(el.getBoundingClientRect().bottom)):0;}
  function setTop(){raf=0;var root=document.documentElement,b=hb();
    if(window.innerWidth>=750){corr=0;
      var pw=document.querySelector('.page-wrapper'),off=b;
      if(pw){var ov=getComputedStyle(pw).overflowY;if(ov==='auto'||ov==='scroll')off=Math.max(0,Math.round(b-pw.getBoundingClientRect().top));}
      root.style.setProperty('--ax-coll-top',off+'px');
      return;}
    root.style.setProperty('--ax-coll-top',(b-corr)+'px');
    var bars=document.querySelectorAll('.ax-coll__bar');
    for(var i=0;i<bars.length;i++){var bar=bars[i],sen=bar.previousElementSibling;
      if(!sen||!sen.classList.contains('ax-coll__sen')){sen=document.createElement('div');sen.className='ax-coll__sen';sen.style.height='0';bar.parentNode.insertBefore(sen,bar);}
      var bt=bar.getBoundingClientRect().top,st=sen.getBoundingClientRect().top;
      if(bt-st>1){var diff=Math.round(bt-b);if(Math.abs(diff)>1){corr+=diff;root.style.setProperty('--ax-coll-top',(b-corr)+'px');}}
    }}
  function q(){if(!raf)raf=requestAnimationFrame(setTop);}
  setTop();window.addEventListener('load',setTop);window.addEventListener('resize',function(){corr=0;q();});window.addEventListener('scroll',q,{passive:true});document.addEventListener('scroll',q,{passive:true,capture:true});
  document.addEventListener('shopify:section:load',function(){corr=0;q();});
})();
